import { useRoutes } from "react-router-dom";

// pages
import Login from "../pages/Login";
import Chat from "../pages/Chat";

export default function Router() {
  return useRoutes([
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/chat/",
      element: <Chat />,
    },
  ]);
}
